import createReducer from '../config/create_reducer';
import Const from '../config/const';

const getDefaultState = () => ({
  loading: false,
  success: false,
  changePasswordInputText: '',
  retypePasswordInputText: '',
  saveButtonActive: false
});

const settingsReducer = createReducer(getDefaultState(), {
  [Const.settings.loading]: (state, { loading }) => ({
    ...state,
    loading
  }),
  [Const.settings.success]: (state) => ({
    ...state,
    loading: false,
    success: true
  }),
  [Const.settings.clear]: () => ({
    ...getDefaultState()
  }),
  [Const.logOut.clear]: () => ({
    ...getDefaultState()
  }),
  [Const.settings.saveInputsValue]: (state, {
    changePasswordInputText,
    retypePasswordInputText
  }) => ({
    ...state,
    changePasswordInputText,
    retypePasswordInputText
  }),
  [Const.settings.saveButtonActive]: (state, { saveButtonActive }) => ({
    ...state,
    saveButtonActive
  }),
  [Const.applicationError.clearError]: (state) => ({
    ...getDefaultState(),
    notificationPreferences: state.notificationPreferences
  }),
  [Const.settings.notificationPreferencesLoaded]: (state, { notificationPreferences }) => ({
    ...state,
    notificationPreferences,
    loading: false
  })
});

export default settingsReducer;
